import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'
import Avatar from '@material-ui/core/Avatar'
import DataGraphPlaceholder from './data-graph-placeholder'
import Skeleton from 'react-loading-skeleton'
import Styles from '../../../common/styles'

class SubscriptionCardSkeleton extends Component {
  render () {
    const { count } = this.props
    var skeleton = []
    for (var i = 0; i < count; i++) {
      skeleton.push(this.skeleton(i))
    }
    return skeleton
  }

  skeleton (i) {
    const { classes } = this.props
    return (
      <Card key={i} className={classes.subscriptionCard}>
        <CardContent>
          <div className={classes.header}>
            <Avatar>
              <Skeleton count={1} />
            </Avatar>
            <div className={classes.headerTitle}>
              <Typography variant='title' style={{ marginBottom: '4px' }}>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body2' className={classes.headerTitleSub} style={{ maxWidth: '200px' }}>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body2' className={classes.headerTitleSub} style={{ maxWidth: '200px' }}>
                <Skeleton count={1} />
              </Typography>
            </div>
          </div>
          <div className={classes.subSummary} style={{ justifyContent: 'space-between' }}>
            <div className={classes.subSummaryItem} style={{ maxWidth: '100px', paddingLeft: '100px' }}>
              <Typography variant='body2'>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='caption' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
            </div>
            <div className={classes.subSummaryItem} style={{ maxWidth: '100px', paddingRight: '100px' }}>
              <Typography variant='body2'>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='caption' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
            </div>
          </div>
        </CardContent>
        <div className={classes.media} style={{ height: '230px', marginTop: '85px' }}>
          <div style={{ paddingLeft: '24px', paddingRight: '24px' }}>
            <div style={{ overflowX: 'scroll' }}>
              <DataGraphPlaceholder />
            </div>
          </div>
        </div>
        <CardContent>
          <div className={classes.subSummary} style={{ justifyContent: 'space-between' }}>
            <div className={classes.subSummaryItem} style={{ maxWidth: '100px', paddingLeft: '100px' }}>
              <Typography variant='body2'>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
            </div>
            <div className={classes.subSummaryItem} style={{ maxWidth: '100px', paddingRight: '100px' }}>
              <Typography variant='body2'>
                <Skeleton count={1} />
              </Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                <Skeleton count={1} />
              </Typography>
            </div>
          </div>
        </CardContent>
        <Divider style={{ marginTop: '20px' }} />
        <CardActions style={{ display: 'flex' }}>
          <Typography variant='title' style={{ flex: '1 1 auto', marginRight: '20px' }}>
            <Skeleton count={1} />
          </Typography>
          <Typography variant='title' style={{ flex: '1 1 auto', marginRight: '20px' }}>
            <Skeleton count={1} />
          </Typography>
          <Typography variant='title' style={{ flex: '1 1 auto' }}>
            <Skeleton count={1} />
          </Typography>
        </CardActions>
      </Card>
    )
  }
}

export default withStyles(Styles)(SubscriptionCardSkeleton)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/subscription-card-skeleton.js